import "./Companies.css";
const Companies = () => {
  return (
    <section className="c-wrapper">
      <div className="paddings innerWidth flexCenter c-container">
        <img src="/img/prologis.png" alt="img-1" />
        <img src="/img/tower.png" alt="img-2" />
        <img src="/img/equinix.png" alt="img-3" />
        <img src="/img/realty.png" alt="img-4" />
      </div>
    </section>
  );
};

export default Companies;
